import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../../config/firebase';
import { signOutUser } from '../../services/authService';
import '../../styles/admin.css';

export default function CompanyLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const credential = await signInWithEmailAndPassword(auth, email, password);
      const firebaseUser = credential.user;

      // Force token refresh to pick up custom claims
      await firebaseUser.getIdToken(true);

      // Confirm this is a company account before sending them to the DSQ.
      const accountSnap = await getDoc(doc(db, 'company_accounts', firebaseUser.uid));
      if (!accountSnap.exists()) {
        await signOutUser();
        setError('No company account found for this email address. Please contact your Mirepa representative.');
        return;
      }

      navigate('/company/dsq');
    } catch (err) {
      if (
        err.code === 'auth/invalid-credential' ||
        err.code === 'auth/wrong-password' ||
        err.code === 'auth/user-not-found'
      ) {
        setError('Invalid email or password. Please try again.');
      } else {
        setError(err.message);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <h1>Mirepa Investment Advisors</h1>
          <p>Deal Screening Portal</p>
        </div>

        <h2 className="auth-title">Sign In</h2>
        <p style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 20, lineHeight: 1.5 }}>
          Use the email address from your invitation email and the password you set.
        </p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleLogin}>
          <div className="form-field" style={{ marginBottom: 16 }}>
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={e => { setEmail(e.target.value); setError(''); }}
              placeholder="your@email.com"
              required
              autoFocus
            />
          </div>
          <div className="form-field" style={{ marginBottom: 24 }}>
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={e => { setPassword(e.target.value); setError(''); }}
              placeholder="Enter your password"
              required
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary btn-full btn-lg"
            disabled={loading}
          >
            {loading ? <span className="spinner spinner-sm" /> : null}
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p style={{ marginTop: 20, fontSize: 12, color: 'var(--color-text-secondary)', textAlign: 'center', lineHeight: 1.6 }}>
          Forgotten your password? Use the "Forgot password?" link on the{' '}
          <a href="/login" style={{ color: 'var(--color-accent)' }}>main login page</a>{' '}
          to reset it, then return here to sign in.
        </p>
      </div>
    </div>
  );
}
